<template>
  <div class="content">
    <div class="pro-mobile">
      <menu-mobile />
    </div>
    <div class="bon-container-frame">
      <!-- member-empty 樣式見 refresh/member-center.css -->
      <div v-if="isNoProd" class="no-data member-empty" role="status">
        <i>
          <img :src="$getThemeImagePath('no-data.png')" alt="">
        </i>
        <p>{{ $t('Bao.no_relevant_data_records') }}</p>
        <span>{{ $t('Bao.search_results_are_empty') }}</span>
      </div>
      <div v-else class="row-frame bon-card-frame">
        <div
          v-for="prod in vipUpgrade"
          :key="prod.id"
          class="colu-12 colu-lg-4 colu-xl-3 colu-xxl-3"
        >
          <div class="bonus-card">
            <div class="bon-card-head">
              <img :src="$getThemeImagePath('vip-bonus.png')" alt="">
            </div>

            <div class="bon-card-body">
              <div class="bon-title-box">
                <div class="bon-title">
                  <div class="con">
                    {{ prod.name }}
                  </div>
                </div>
                <div class="bon-description" @click="showModel(prod)">
                  {{ $t('Bao.bonus_view_detail') }}
                </div>
              </div>
              <div class="bon-con-box">
                <div class="bon-con">
                  <div class="bonConText">
                    {{ $t('Bao.bonus_reward') }}
                  </div>
                  <div class="amount font-w-b">
                    {{ prod.upgrade_prize }}
                  </div>
                </div>
                <div class="bon-btn">
                  <button class="btn btn-primary" @click="confirmPurchase(prod)">
                    <span>{{ $t('Bao.redeem') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="prod in otherProdData"
          :key="prod.id"
          class="colu-12 colu-lg-4 colu-xl-3 colu-xxl-3"
        >
          <div class="bonus-card">
            <div class="bon-card-head">
              <img :src="getBonusImage(prod.product_type)" alt="">
            </div>

            <div class="bon-card-body">
              <div class="bon-title-box">
                <div class="bon-title">
                  <div class="con">
                    {{ prod.name }}
                  </div>
                </div>
                <div class="bon-description" @click="showModel(prod)">
                  {{ $t('Bao.bonus_view_detail') }}
                </div>
              </div>
              <div class="bon-con-box">
                <div class="bon-con">
                  <div class="bonConText">
                    {{ $t('Bao.bonus_reward') }}
                  </div>
                  <div class="amount font-w-b">
                    {{ prod.reward | numberFormat }}
                  </div>
                </div>
                <div class="bon-btn">
                  <button class="btn btn-primary" @click="confirmPurchase(prod)">
                    <span>{{ $t('Bao.redeem') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-purchase-modal :is-active="showModal" :selected-prod="selectedProd" @hideModel="hideModel" />
    </div>
  </div>
</template>

<script>
import { showNotice } from '@/utils/tool'
import { getAllProductInfo, purchaseProd } from '@/api/shop'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'
import menuMobile from '@/components/shop/menuMobile'

export default {
  name: 'AllBonus',
  components: {
    confirmPurchaseModal,
    menuMobile
  },
  data() {
    return {
      allProd: [],
      vipUpgrade: [],
      otherProdData: [],
      showModal: false,
      selectedProd: {},
      isNoProd: true
    }
  },
  watch: {
    '$store.state.user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_SHOP_PURCHASE', false)
      }
    }
  },
  created() {
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProductInfo()
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    getAllProductInfo() {
      getAllProductInfo().then((response) => {
        const data = response.data.data.data

        this.otherProdData = [
          ...(data.vip_birthday || []).map(item => ({ ...item, product_type: 'vip_birthday' })),
          ...(data.vip_weekly || []).map(item => ({ ...item, product_type: 'vip_weekly' })),
          ...(data.vip_monthly || []).map(item => ({ ...item, product_type: 'vip_monthly' })),
          ...(data.rebate || []).map(item => ({ ...item, product_type: 'rebate' }))
        ]

        this.handleVipUpgrade(data.vip_upgrade)
        this.handleOtherProd(this.otherProdData)

        this.allProd = [
          ...(this.vipUpgrade || []),
          ...(this.otherProdData || [])
        ]

        if (this.allProd.length === 0) {
          this.isNoProd = true
        } else {
          this.isNoProd = false
        }
      }).catch(error => {
        this.isNoProd = true
        this.allProd = []
        showNotice(error.response.data.msg)
      })
    },
    buyProd(prod) {
      purchaseProd({ id: prod.id, sub_id: prod.sub_id }).then((response) => {
        showNotice(this.$t('Bao.success'))
        this.getAllProductInfo()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    showModel(prod) {
      this.selectedProd = prod
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    },
    confirmPurchase(prod) {
      this.selectedProd = prod
      this.$store.commit('SET_SHOP_PURCHASE', true)
      this.showModal = false
    },
    getBonusImage(productType) {
      const imageMap = {
        'vip_birthday': 'birth-bonus.png',
        'vip_weekly': 'weekly-bonus.png',
        'vip_monthly': 'monthly-bonus.png',
        'rebate': 'rebate-bonus.png'
      }
      return this.$getThemeImagePath(imageMap[productType] || 'birth-bonus.png')
    },
    handleVipUpgrade(vipUpgradeData) {
      if (!vipUpgradeData || vipUpgradeData.length === 0) return

      this.vipUpgrade = vipUpgradeData
        .filter(prod => prod.avaible === 1)
        .map(prod => ({
          ...prod,
          type: 2,
          type_name: this.$t('Bao.point_type_vip')
        }))
    },
    handleOtherProd(otherProdData) {
      if (!otherProdData || otherProdData.length === 0) return

      this.otherProdData = otherProdData
        .filter(prod => prod.avaible === 1)
        .map(prod => ({
          ...prod,
          type: 1
        }))
    }
  }
}
</script>
